export default __webpack_public_path__ + "static/media/cif-bt.c9649317.svg";